import router from "../router";
import xz from "../common";

const menu = {
    state: {
        router: [],
        leftNum:'',
        proRemindNum:''
    },
    mutations: {
        SET_ROUTERS: (state, router) => {
            state.router = router
        },
        getLeftNum(state) {
            // xz.getremindcount().then(res => {
            //     if(res){
            //         state.leftNum = res;
            //         // console.log('aaa',state.leftNum)
            //     }else{
            //         state.leftNum = ''
            //         // console.log('bbb')
            //     }
            // })
        },
        // 项目合同提醒数量
        SET_Pronum(state) {
            let listQuery = {
                projectname:'', // 项目名称
                projectid:'', // 项目id
                perpage: 5,
                currpage: 1,
                strorgancode: localStorage.gancode,
                roletype: localStorage.loginRoletype
            }
            xz.getRemindProjectLists(listQuery).then(res => {
                if(res.status == 'ok'){
                    state.proRemindNum = res.totalcount
                    // console.log('aaa',res)
                }else{
                    state.proRemindNum = ''
                    // console.log('bbb')
                }
            })
        }
    },
    actions: {
        SetRouter({ commit }, routers) {
            // console.log("SET_ROUTERS", routers)
            commit("SET_ROUTERS", routers)
        },
        // SetProNum({ commit }, proRemindNum) {
        //     console.log("SetProNum", proRemindNum)
        //     commit("SET_Pronum", proRemindNum)
        // }
    },
    getter:{
        getterLeftNum(state){
            return(state.leftNum)
        },
        getterProNum(state){
            return(state.proRemindNum)
        }
    }
}
export default menu